import { createContext, useContext, useState, useCallback } from "react";
import { translations } from "@/data/translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const stored = localStorage.getItem("mc-lang");
    if (stored) return stored;
    return (navigator.language || "").toLowerCase().startsWith("nl") ? "nl" : "en";
  });

  const setLanguage = useCallback((l) => {
    setLang(l);
    localStorage.setItem("mc-lang", l);
    document.documentElement.lang = l;
    if (window.dataLayer) window.dataLayer.push({ event: "language_switch", language: l });
  }, []);

  const t = translations[lang];
  return (
    <LanguageContext.Provider value={{ lang, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}

// Lightweight analytics event hook (GA4/GTM/Meta placeholders).
export function track(event, params = {}) {
  if (window.dataLayer) window.dataLayer.push({ event, ...params });
  // Google Ads conversion: "Start your intro" click to Bsport (click-only, 1 per click)
  if (event === "intro_offer_click" && typeof window.gtag === "function") {
    window.gtag("event", "conversion", { send_to: "AW-18304818787/dLfHCMyC8OgcEOO8tZhE" });
  }
}
